<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-02-23 08:35:22
 * @LastEditors: may.li
 * @LastEditTime: 2023-03-14 10:04:36
-->
<template>
	<div class="page-yuekan-order-detail">
		<div class="detail-section">
			<div class="wechat-wrap" v-if="showQrcode">
				<img :src="imageUrl+qrcodeUrl" alt="" class="code-tu">
			</div>
			<img :src="publicPath+'/statics/images/my/yuekan-order-bg.png'" alt="" class="concat-bg" v-if="showQrcode">
			<div class="info-wrap" v-if="orderInfo">
				<div class="info-list">
					<div class="info-item">
						<div class="item-l">名称</div>
						<div class="item-r">{{ orderInfo.live_title }}</div>
					</div>
					<div class="info-item">
						<div class="item-l">状态</div>
						<div class="item-r">{{ orderInfo.status == 0 ? '已取消' : orderInfo.pay_status != 2 ? '待支付' : orderInfo.fx_status == 1 ? '已核销' : '待核销' }}</div>
					</div>
					<div class="info-item">
						<div class="item-l">活动地址</div>
						<div class="item-r">{{ orderInfo.address }}</div>
					</div>
					<div class="info-item">
						<div class="item-l">活动时间</div>
						<div class="item-r">{{ orderInfo.live_starttime }}</div>
					</div>
					<div class="info-item">
						<div class="item-l">购买票数</div>
						<div class="item-r">{{ orderInfo.nums }}</div>
					</div>
				</div>
				<div class="info-list" v-for="(titem,tkey) in orderInfo.data" :key="tkey">
					<div class="info-item">
						<div class="item-l">门票信息</div>
						<div class="item-r">{{ orderInfo.ticket_title }}</div>
					</div>
					<div class="info-item">
						<div class="item-l">票号信息</div>
						<div class="item-r">{{ titem.ticket_num }}</div>
					</div>
				</div>
				<div class="info-list">
					<div class="info-item">
						<div class="item-l">场次信息</div>
						<div class="item-r">{{ orderInfo.ticket_field_title }}</div>
					</div>
					<div class="info-item">
						<div class="item-l">开场时间</div>
						<div class="item-r">{{ orderInfo.start_time }}</div>
					</div>
					<div class="info-item">
						<div class="item-l">订单编号</div>
						<div class="item-r">{{ orderInfo.order_num }}</div>
					</div>
					<div class="info-item">
						<div class="item-l">下单时间</div>
						<div class="item-r">{{ orderInfo.created_at }}</div>
					</div>
					<div class="info-item">
						<div class="item-l">联系电话</div>
						<div class="item-r">{{ orderInfo.trad_phone }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="actions-wrap" v-if="orderInfo">
			<div class="action" v-if="orderInfo.status == 1 && orderInfo.pay_status != 2 " @click="toBuy">支付</div>
			<div class="action" v-if="orderInfo.status == 1 && orderInfo.is_quxiao == 1 " @click="cancelOrder">取消</div>
		</div>
	</div>
</template>
<script>
import {
    Toast
} from 'vant'
export default {
	data(){
		return{
			token: null,
			id: null,
			orderInfo: null,
			showQrcode: false,
			qrcodeUrl: null,
			publicPath: process.env.BASE_URL,
			imageUrl: this.$publicData.uploadImage
		}
	},
	created(){
		this.token = this.$store.getters.token;
		this.id = this.$route.query.id;
		if(this.id){
			this.getData();
		}
	},
	methods: {
		/**
		 * @name: 获取订单详情
		 * @return {*}
		 * @desc: 
		 */		
		getData(){
			let params = {
				token: this.token,
				order_id: this.id
			};
			this.$api.live.orderDetail(params).then(res=>{
				if(res.code == 200){
					let info = res.result;
					this.orderInfo = info;
					this.qrcodeUrl = info.write_off_qrcode;
					if(info.status == 1 && info.pay_status == 2 && info.fx_status != 1){
						this.showQrcode = true;
					};
				}
			})
		},
		/**
		 * @name: 跳转支付
		 * @return {*}
		 * @desc: 
		 */		
		toBuy(){
			this.$router.push({
                path: '/yuekan/pay',
                query: {
                    orderId: this.orderInfo.order_num,
                    price: this.orderInfo.total_prices,
					is_chargecard: this.orderInfo.is_chargecard
                }
            })
		},
		/**
		 * @name: 取消
		 * @return {*}
		 * @desc: 
		 */		
		cancelOrder(){
			let that = this;
			let params = {
				token: this.token,
				order_id: this.id
			};
			that.$api.live.cancelLive(params).then(res=>{
				if(res.code == 200){
					that.$toast(res.message);
					that.getData();
				}else if(res.code == 201){
					Toast.loading({
						type: 'html',
						duration: 3000,
						message: res.message,
						forbidClick: true
					});
					that.getData();
				}
			})
		}
	}
}	
</script>